import React, { memo } from 'react'
import Icon from '../Icon'
import './index.scss'

// props
interface IProps {
  /** 值 */
  value: boolean;
  /** 子节点 */
  children?: React.ReactNode;
  /** change事件 */
  onChange: (value: boolean) => void;
}

const Radio: React.FC<IProps> = ({ value, children, onChange }) => {
  // 处理change事件
  const handleChange = (e: any) => {
    e.stopPropagation()
    onChange(!value)
  }

  return (
    <button className='radio-wrapper' data-cypid='radioWrapper' onClick={handleChange}>
      <span className={`radio-inner${value ? ' active' : ''}`}>
        {value && <Icon name='check' />}
      </span>
      {!!children && children}
    </button>
  )
}

export default memo(Radio)
